import React from 'react';
import List from '@material-ui/core/List';
import _ from 'lodash';
import MuiCheckbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './OptionListCheckbox.styles';
import { mainColor, ALL_POS_TYPES, SUFFIX } from '../../constants';
import { getDisplayedCategories } from 'src/utils/shopUtils';
const Checkbox = withStyles(() => ({
  checked: {
    color: `${mainColor.secondaryColor} !important`
  }
}))(MuiCheckbox);
const OptionListCheckbox = props => {
  const { classes, categoriesArray, selectedCategories, categories, addOption, originalCategories, isOptionModal, disableOption } = props;
  const displayedCategories = getDisplayedCategories(categories, originalCategories);
  const getKeyWithoutSuffix = (key) => {
    let newKey = key
    SUFFIX.split(',').map(elm => {
      if (key.includes(elm)) {
        newKey = newKey.replace(elm, '')
      }
    })

    return newKey
  }
  return (
    <>
      <div className='row mx-0 mt-2'>
        <p className={classes.title}>
          Choisissez vos {isOptionModal ? 'sous' : ''} listes d'options
        </p>
        {isOptionModal && (
          <p className='secondery-text mt-0'>
            <small>
              * Cela permet de déclencher une liste d'options lorsque votre client sélectionne cette
              option.
            </small>
          </p>
        )}
      </div>
      <List className={classes.listOptions}>
        {selectedCategories && _.map(selectedCategories, (option) => {
          const index = _.findIndex(categoriesArray, elt => elt.key === option.key);
          const type = ALL_POS_TYPES[option.type] ? `- ${ALL_POS_TYPES[option.type]}` : ''
          return <div className={classes.checkboxList} key={option.key} onClick={() => addOption(option.key, index)}
          >
            <Checkbox
              checked={categoriesArray.some(elt => elt.key === option.key)}
              id='option'
              name='option'
            />
            <p className={classes.optionName}>
              {option.name}
              <small className={`${classes.descriptionStyle} secondery-text`}> {type.toUpperCase()} - {getKeyWithoutSuffix(option?.key)} </small>
            </p>
            <span className={classes.indexStyle}>{index > -1 ? ` (${index + 1})` : ''}</span>
          </div>
        })}

        {displayedCategories &&
          _.keys(displayedCategories)
            .filter(categoryKey => !selectedCategories?.some(selectedCategory => selectedCategory.key === categoryKey))
            .sort((a, b) => categories[a]?.name?.localeCompare(categories[b].name))
            .map(categoryKey => {
              const index = _.findIndex(categoriesArray, elt => elt.key === categoryKey);
              const enabledOption = _.findIndex(selectedCategories, elt => elt.key === categoryKey);
              const type = ALL_POS_TYPES[displayedCategories[categoryKey].type] ? `- ${ALL_POS_TYPES[displayedCategories[categoryKey].type]}` : ''
              return (
                <div
                  className={classes.checkboxList}
                  key={categoryKey}
                  onClick={() => addOption(categoryKey, index)}
                  role='button'
                  aria-hidden='true'
                  style={disableOption && enabledOption < 0 ? { opacity: 0.5, pointerEvents: 'none' } : {}} >
                  <Checkbox
                    checked={categoriesArray.some(elt => elt.key === categoryKey)}
                    id='option'
                    name='option'
                  />
                  <p className={classes.optionName}>
                    {displayedCategories[categoryKey].name}
                    <small className={`${classes.descriptionStyle} secondery-text`}> {type.toUpperCase()} - {getKeyWithoutSuffix(categoryKey)}  </small>
                  </p>
                  <span className={classes.indexStyle}>{index > -1 ? ` (${index + 1})` : ''}</span>
                </div>
              );
            })}
      </List>
    </>
  );
};

export default withStyles(styles)(OptionListCheckbox);
